import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';
import {Button, Image} from '@learningblocks/shared-components';

/**
 * LevelItem:
 *  - Button for a single simulation level
 */
export function LevelItem(props) {
  const onClick = (event) => {
    event.preventDefault();
    props.onClick(props.value);
  };

  let className = 'levelSelector-level';

  if (props.selected) className += ' active';
  else className += ' inactive';

  return (
    <Button className={className} onClick={onClick} tabIndex={0} dir="auto">
      <Image className='level-image' src={window.location.origin + window.location.pathname + props.image} alt={props.label} />
      <div className='levelSelector-level_content'>
        <h3 className='level-title'><FormattedMessage
                  id={props.label}
                  defaultMessage={props.label}
                /></h3>
        <p className='level-info'><FormattedMessage
                  id={props.description}
                  defaultMessage={props.description}
                /></p>
      </div>
    </Button>
  );
}

LevelItem.propTypes = {
  /**
   * Image for LevelItem
   */
  image: PropTypes.string.isRequired,
  /**
   * Label for LevelItem
   */
  label: PropTypes.string.isRequired,
  /**
   * Description for LevelItem
   */
  description: PropTypes.string.isRequired,
  /**
   * Boolean set of LevelItem Selected
   */
  selected: PropTypes.bool.isRequired,
  /**
   * Unique name to identify LevelItem
   */
  value: PropTypes.string.isRequired,
};

LevelItem.defaultProps = {
  image: '',
  label: '',
  description: '',
  selected: false,
  value: '',
};
